import React, { useEffect, useState } from "react";
import API from "../../../services/api";

const StatCard = ({ title, value, icon, color, bg }) => (
  <div className="col-12 col-sm-6 col-xl-3">
    <div className="card border-0 shadow-sm rounded-4 h-100">
      <div className="card-body d-flex align-items-center gap-3 p-4">
        <div
          className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: 56, height: 56, background: bg }}
        >
          <i className={`bi ${icon} fs-4`} style={{ color }}></i>
        </div>
        <div>
          <div className="text-muted small">{title}</div>
          <div className="fw-bold fs-4">
            {value ?? (
              <span className="spinner-border spinner-border-sm"></span>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    API.get("/reports/dashboard")
      .then((res) => setStats(res.data.data))
      .catch((err) => console.error(err));
  }, []);

  const grievanceTotal = stats
    ? Object.values(stats.grievances).reduce((a, b) => a + b, 0)
    : null;

  const projectTotal = stats
    ? Object.values(stats.projects).reduce((a, b) => a + b, 0)
    : null;

  return (
    <div>
      {/* Header */}
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Dashboard</h4>
        <p className="text-muted small mb-0">
          Welcome back! Here's what's happening.
        </p>
      </div>

      {/* Stat Cards */}
      <div className="row g-3 mb-4">
        <StatCard
          title="Total Voters"
          value={stats?.total_voters?.toLocaleString()}
          icon="bi-people-fill"
          color="#1a3c5e"
          bg="#e8f0fe"
        />
        <StatCard
          title="Grievances"
          value={grievanceTotal}
          icon="bi-chat-left-text-fill"
          color="#d97706"
          bg="#fef3c7"
        />
        <StatCard
          title="Dev Projects"
          value={projectTotal}
          icon="bi-building-fill"
          color="#2d6a4f"
          bg="#d1fae5"
        />
        <StatCard
          title="Beneficiaries"
          value={stats?.total_beneficiaries?.toLocaleString()}
          icon="bi-heart-fill"
          color="#dc2626"
          bg="#fee2e2"
        />
      </div>

      {/* Grievance + Project Status */}
      <div className="row g-3">
        {/* Grievance Status */}
        <div className="col-12 col-lg-6">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body p-4">
              <h6 className="fw-semibold mb-3">
                <i className="bi bi-chat-left-text me-2 text-warning"></i>
                Grievance Status
              </h6>
              {stats ? (
                Object.entries(stats.grievances).map(([status, count]) => (
                  <div key={status} className="mb-2">
                    <div className="d-flex justify-content-between small mb-1">
                      <span>{status}</span>
                      <span className="fw-semibold">{count}</span>
                    </div>
                    <div className="progress" style={{ height: "6px" }}>
                      <div
                        className="progress-bar"
                        style={{
                          width: `${(count / (grievanceTotal || 1)) * 100}%`,
                          background:
                            "linear-gradient(135deg, #1a3c5e, #2d6a4f)",
                        }}
                      ></div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary"></div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Project Status */}
        <div className="col-12 col-lg-6">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body p-4">
              <h6 className="fw-semibold mb-3">
                <i className="bi bi-building me-2 text-success"></i>
                Project Status
              </h6>
              {stats ? (
                Object.entries(stats.projects).map(([status, count]) => (
                  <div key={status} className="mb-2">
                    <div className="d-flex justify-content-between small mb-1">
                      <span>{status}</span>
                      <span className="fw-semibold">{count}</span>
                    </div>
                    <div className="progress" style={{ height: "6px" }}>
                      <div
                        className="progress-bar bg-success"
                        style={{
                          width: `${(count / (projectTotal || 1)) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-success"></div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Message Stats */}
        <div className="col-12">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-4">
              <h6 className="fw-semibold mb-3">
                <i className="bi bi-chat-dots me-2 text-primary"></i>
                Message Summary
              </h6>
              <div className="row g-3">
                {stats ? (
                  Object.entries(stats.messages).map(([status, count]) => (
                    <div key={status} className="col-6 col-md-3">
                      <div className="text-center p-3 rounded-3 bg-light">
                        <div className="fw-bold fs-5">{count}</div>
                        <div className="text-muted small">{status}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-2">
                    <div className="spinner-border spinner-border-sm"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
